import React  from 'react'
import './OpenBets.scss'
import { connectOpenBets } from './OpenBets.connect'
import OpenBetsList from '../OpenBetsList/OpenBetsList'
import { toastr } from 'react-redux-toastr'

const OpenBets = ({ timeSettings, openBets, redirect, isEvent, actions }) => {

  const cancel = (orderId) => {
    actions
      .requestCancelOrder(orderId)
      .then((res) => {
        toastr.success('', 'Your bet was canceled successfully.')
      })
      .catch((e) => {
        if (e.status && e.status[0] && e.status[0].description)
          toastr.error('', e.status[0].description)
        else toastr.error('', 'Something went wrong')
      })
  }

// console.log('unmatched', openBets?.unmatched);

  const cancelAll = () => {
    actions
      .requestCancelAllBets()
      .then((res) => {
        toastr.success('', 'Your bet was canceled successfully.')
      })
      .catch((e) => {
        if (e.status && e.status[0] && e.status[0].description)
          toastr.error('', e.status[0].description)
        else toastr.error('', 'Something went wrong')
      })
  }
  return (
    <section className="OpenBets">
      {openBets ? (
        <>
          <OpenBetsList
            bets={openBets.unmatched}
            timeSettings={timeSettings}
            isEvent={isEvent}
            redirect={redirect}
            isUnmatched={true}
            title="Unmatched Bets"
            cancel={cancel}
            cancelAll={cancelAll}
          />
          <OpenBetsList
            bets={openBets.matched}
            timeSettings={timeSettings}
            isEvent={isEvent}
            redirect={redirect}
            title="Matched Bets"
          />
        </>
      ) : null}
    </section>
  )
}

export default connectOpenBets()(OpenBets)
